import React from "react";
import { Link as ChakraLink, LinkProps } from "@chakra-ui/react";
import NextLink from "next/link";

const Link = ({
  href = "#",
  children,
  ...rest
}: Omit<LinkProps, "href"> & {
  href: string | { pathname: string; query: {} };
}) => (
  <ChakraLink
    as={NextLink}
    // @ts-expect-error
    href={href}
    fontWeight={500}
    _hover={{ opacity: 0.6 }} // value matches "Button > link" in chakra-theme.ts
    _active={{ opacity: 0.4 }} // value matches "Button > link" in chakra-theme.ts
    textDecoration="none"
    {...rest}
  >
    {children}
  </ChakraLink>
);

export default Link;
